import { render, staticRenderFns } from "./StagesTab.vue?vue&type=template&id=5989a75e&scoped=true"
import script from "./StagesTab.vue?vue&type=script&lang=js"
export * from "./StagesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989a75e",
  null
  
)

export default component.exports